import { ReactNode, useEffect, useState } from 'react';

const localStorageKey = 'consumer-theme';

const getCurrentTheme = () => {
    let theme = 'light';
    if (window?.matchMedia) {
        const isMatchesDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
        theme = isMatchesDark ? 'dark' : 'light';
    }
    return theme;
};
const getCurrentThemeForText = () => getCurrentTheme();

const useThemeDetector = () => {
    const [theme, setTheme] = useState(getCurrentTheme());

    useEffect(() => {
        const mediaQueryList = window?.matchMedia('(prefers-color-scheme: dark)');
        const setQuery = () => {
            const currentTheme = getCurrentTheme();
            setTheme(currentTheme);
            document.documentElement.setAttribute('data-theme', currentTheme);
            localStorage?.setItem(localStorageKey, currentTheme);
        };
        setQuery();
        mediaQueryList?.addEventListener('change', setQuery);

        return () => {
            mediaQueryList?.removeEventListener('change', setQuery);
        };
    }, []);
    return theme;
};

interface ProviderProps {
    children: ReactNode;
}

const ConsumerThemeProvider = ({ children }: ProviderProps) => {
    useThemeDetector();

    return children;
};
export { ConsumerThemeProvider, useThemeDetector, getCurrentThemeForText };
